import useWishlist from 'hooks/account/lists/useWishlist'
import * as React from 'react'
import styled from 'styled-components'
import ProductWidgetSeries from 'theme/molecules/ProductWidgetSeries'
import bySw6Uuid from 'utils/productListFetcher/bySwUuid'
import { Product } from 'utils/productListFetcher/types'
import EmptyWishlist from './EmptyWishlist'
import theme from 'theme'
import useTranslations from 'hooks/useTranslations'

export default function WishlistItems() {
  const wishlist = useWishlist()
  const t = useTranslations<'templates-Wishlist'>()
  const [hits, setHits] = React.useState<Product[]>([])
  const [isFetching, setIsFetching] = React.useState(true)

  React.useEffect(() => {
    if (wishlist.isLoading) return
    const ids = Array.from(wishlist.sw6uuids)

    if (ids.length === 0) {
      setHits([])
      setIsFetching(false)
      return
    }

    bySw6Uuid({
      sw6Uuids: ids,
      keepSorting: true,
      maxHits: 1000,
      noDistinct: true
    })(0)
      .then((result) => setHits(result.data))
      .finally(() => setIsFetching(false))
  }, [Array.from(wishlist.sw6uuids).join(''), wishlist.isLoading])

  if (isFetching) {
    return (
      <Wrapper className="WishlistItems">
        <div className="fetching-overlay" />
      </Wrapper>
    )
  }

  if (wishlist.sw6uuids.size === 0) {
    return (
      <Wrapper className="WishlistItems">
        <EmptyWishlist />
      </Wrapper>
    )
  }

  return (
    <Wrapper className="WishlistItems">
      <h1>{t('wishlist_label')}</h1>
      <p>{t('wishlist_description')}</p>
      {hits.map((hit, i) => (
        <ProductWidgetSeries
          hit={hit}
          key={hit.sku}
          listname="wishlist"
          listPosition={i}
          listid={typeof window !== 'undefined' ? window.location.href : ''}
          evtSource="wishlist"
        />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: ${theme.spacing('l')};
  > h1 {
    ${theme.ty('rc-3xl', null, 'rc-4xl')}
    color: ${theme.colors.primary};
    margin-bottom: ${theme.spacing('m')};
  }
  > p {
    margin: 0;
    ${theme.ty('r-s', null, 'r-base')};
    margin-bottom: ${theme.spacing('l')};
  }
  .fetching-overlay {
    height: 500px;
  }

  > .ProductWidgetSeries {
    margin-bottom: ${theme.spacing('m')};
  }
`
